import { Text } from "../Text"
import { RadioButton } from "./RadioButton"
import styles from "./RadioCard.module.css"
import { RadioItem } from "./RadioItem"

export interface RadioCardProps {
  title: string
  disabled?: boolean
}

export function RadioCard(props: RadioCardProps) {
  const { title, disabled = false } = props

  return (
    <RadioItem disabled={disabled}>
      <div className={styles.root}>
        <RadioButton decorative />
        <Text variant="h4">{title}</Text>
      </div>
    </RadioItem>
  )
}
